<template>
  <div
    :class="[
      statusSurface({ variant }),
      'rounded-md px-4 py-2 text-sm',
      $slots.actions
        ? 'flex flex-col items-stretch gap-2 sm:flex-row sm:items-center sm:justify-between'
        : 'flex items-center gap-2',
    ]"
  >
    <div class="flex min-w-0 flex-1 items-center gap-2">
      <component :is="statusIcon" v-if="showIcon" class="size-4 shrink-0" aria-hidden="true" />
      <div class="min-w-0 break-words">
        <slot />
      </div>
    </div>
    <div v-if="$slots.actions" class="flex flex-wrap gap-2 sm:shrink-0">
      <slot name="actions" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { statusSurface, type BadgeVariant } from '@carvia/theme/lib/cva/badge';
import { computed, type Component } from 'vue';
import { AlertTriangleIcon, CircleCheckIcon, CircleXIcon, InfoIcon } from 'lucide-vue-next';

export type StatusBannerVariant = Extract<
  BadgeVariant,
  'info' | 'success' | 'warning' | 'problem' | 'danger'
>;

const ICON_BY_VARIANT: Record<StatusBannerVariant, Component> = {
  info: InfoIcon,
  success: CircleCheckIcon,
  warning: AlertTriangleIcon,
  problem: CircleXIcon,
  danger: CircleXIcon,
};

const props = withDefaults(
  defineProps<{
    variant?: StatusBannerVariant;
    showIcon?: boolean;
  }>(),
  { variant: 'info', showIcon: true },
);

const statusIcon = computed(() => ICON_BY_VARIANT[props.variant]);
</script>
